import { Col, Span } from 'components'
import { Controller } from 'react-hook-form'
import { CountryData } from 'react-phone-input-2'
import { COLORS } from 'utils'

import { CustomInput, InputLabelCustom, InputStyles } from './PhoneInput.styles'
interface IPhoneInput extends InputStyles {
  control?: any
  errors?: any
  label?: string
  formValue?: string
  value?: string
  required?: boolean
  placeholder?: string
  onClickIcon?: () => void
  onChange?: (
    _value: string,
    _data: {} | CountryData,
    _event: React.ChangeEvent<HTMLInputElement>,
    _formattedValue: string
  ) => void
  disabled?: boolean
  defaultValue?: string
  customError?: any
}

const PhoneInput: React.FC<IPhoneInput> = ({
  customError,
  control,
  label,
  errors,
  required,
  placeholder,
  disabled = false,
  marginTop,
  value,
  onChange,
  marginBottom,
  marginLeft,
  marginRight,
  formValue,
  defaultValue = '',
  width
}) => {
  const hasError = (errors && errors[formValue]) || customError
  const error = hasError && errors ? errors[formValue] : customError
  const formatLabel = label?.charAt(0).toUpperCase() + label?.slice(1)

  return (
    <Col
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginTop={marginTop}
    >
      <InputLabelCustom hasError={hasError}>
        {formatLabel || ''}
      </InputLabelCustom>
      {control ? (
        <Controller
          control={control}
          name={formValue}
          defaultValue={defaultValue}
          rules={{ required }}
          render={({ field }) => (
            <CustomInput
              width={width}
              country={'br'}
              value={field.value}
              onChange={field.onChange}
              placeholder={placeholder}
              disabled={disabled}
              autoFormat
              enableSearch
              searchPlaceholder="Busca por países."
              searchNotFound="Nenhum país encontrado."
            />
          )}
        />
      ) : (
        <CustomInput
          width={width}
          country={'br'}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          autoFormat
          enableSearch
          searchPlaceholder="Busca por países."
          searchNotFound="Nenhum país encontrado."
        />
      )}
      {hasError && (
        <Span text={error?.message || 'Erro.'} color={COLORS.error} />
      )}
    </Col>
  )
}

export default PhoneInput
